import * as React from 'react';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import Paper from '@mui/material/Paper';
import Popover from '@mui/material/Popover';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';
import NotificationsNoneOutlinedIcon from '@mui/icons-material/NotificationsNoneOutlined';
import { NewsFeedItem } from '../NewsApi';
import NewsFeedArticle from './NewsFeedArticle';
import { NewsFeedLabels } from './newsFeedLabels';
import { newsPaneWidth } from './newsPaneStyle';

type NewsFeedPanelProps = {
    anchorElement: HTMLElement | null;
    newsItems: NewsFeedItem[];
    labels: NewsFeedLabels;
    onClose: () => void;
};

function NoNews({ label }: { label: string }) {
    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: 1,
                padding: '32px 24px'
            }}
        >
            <NotificationsNoneOutlinedIcon sx={{ fontSize: 40, color: 'rgba(0, 0, 0, 0.26)' }} />
            <Typography sx={{ fontSize: 14, color: 'rgba(97, 97, 97, 1)' }}>{label}</Typography>
        </Box>
    );
}

export default function NewsFeedPanel({
    anchorElement,
    newsItems,
    labels,
    onClose
}: NewsFeedPanelProps) {
    return (
        <Popover
            open={Boolean(anchorElement)}
            anchorEl={anchorElement}
            onClose={onClose}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
            transformOrigin={{ vertical: 'top', horizontal: 'center' }}
            sx={{ top: '16px' }}
        >
            <Paper sx={{ width: newsPaneWidth }}>
                <Box sx={{ display: 'flex', alignItems: 'center', padding: '12px 12px 12px 20px' }}>
                    <Typography
                        component="h2"
                        sx={{ flexGrow: 1, fontWeight: 'bold', fontSize: '18px', color: '#454545' }}
                    >
                        {labels.newsTitle}
                    </Typography>
                    <Tooltip title={labels.closeTooltip} placement="left">
                        <IconButton aria-label={labels.closeTooltip} onClick={onClose} size="small">
                            <CloseIcon />
                        </IconButton>
                    </Tooltip>
                </Box>
                <Divider />
                <Box sx={{ maxHeight: '460px', overflowY: 'auto' }}>
                    {newsItems.length === 0 ? (
                        <NoNews label={labels.noNews} />
                    ) : (
                        newsItems.map((item) => (
                            <NewsFeedArticle key={item.id} item={item} labels={labels} />
                        ))
                    )}
                </Box>
            </Paper>
        </Popover>
    );
}
